<template>
    <section
        class="hero section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div class="hero-content">
                    <div class="container-xs">
                        <h1 class="mt-0 reveal-from-left">
                            Customs Clearance &amp; Importation Services
                        </h1>
                        <p class="reveal-from-left" data-reveal-delay="200">
                            A licensed customs broker in-house, backed by our own 1,467&nbsp;m&sup2; warehouse in Kewdale, next to Perth Airport.
                        </p>
                        <p class="hero-zh reveal-from-left" data-reveal-delay="200">澳洲持牌报关行,中英双语服务。</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'

export default {
  name: 'CHeroFull',
  mixins: [SectionProps]
}
</script>

<style scoped>
.hero-zh {
    font-size: 13px;
    opacity: .7;
    margin-top: 6px;
}
</style>
